import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    palette: {
        primary: {
            main: '#FF6D00',
            light: '#FFAB40',
            dark: '#E65100',
        },
        secondary: {
            main: '#FF9100',
        },
        background: {
            default: '#FFF8F2',
        },
    },
    typography: {
        fontFamily: '"Segoe UI", Tahoma, Geneva, Verdana, sans-serif',
    },
});

export default theme;